<template>
  <v-layout column="" v-if="notShow" fill-height="" justify-center="" align-center="" class="pa-5 pb-10 text-center">
      <v-icon size="100" color="primary">mdi-shield-account</v-icon>
      <div class="ma-1 not-f7 font-weight-bold primary--text">
        ACCESS DENIED
      </div> 
      <div >
        You are not allowed to access this page. For more info contact admin.
      </div>
      <div>
        <v-btn :loading="!ud" class="mt-3" to="/" color="primary">Home</v-btn>
      </div>
  </v-layout>   
</template>

<script>
export default {
  props:["not","notShow"],
  data: () => ({
    
  }),
  computed: {
    ud(){
        return this.not.ud
    },
  },  
  methods: {
     
  },
};
</script>
